/*
 * @FilePath: \hotOrder-frontend\src\router\modules\suggestReply.js
 * @Description: 建议回复路由
 */
import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};

export default {
  path: "/suggestReply",
  name: "suggestReply",
  redirect: {
    name: "suggestReply",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/suggestReply/noRelyList",
      name: "noRelyList",
      meta: {
        ...meta,
        title: "待回复",
      },
      component: () => import("@/pages/suggestReply/replyList.vue"),
    },
    {
      path: "/suggestReply/repliedList",
      name: "repliedList",
      meta: {
        ...meta,
        title: "已回复",
      },
      component: () => import("@/pages/suggestReply/replyList.vue"),
    },
    {
      path: "/suggestReply/replyDetail",
      name: "replyDetail",
      meta: {
        ...meta,
        title: "回复详情",
      },
      component: () => import("@/pages/suggestReply/replyDetail.vue"),
    },
  ],
};
